
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generated-templates/article-template-page",
      function () {
        return require("private-next-pages/generated-templates/article-template-page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/generated-templates/article-template-page"])
      });
    }
  